import * as vp from 'vopay';
import { FieldData } from '../../../../Form/types';
const { TextField, Tooltip } = vp;
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const buildSubAccountRows = (): FieldData<vp.CreateSubAccountRequest>[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.Create.Form' });

  return [
    {
      label: () => t('LegalBusinessName.label'),
      fieldName: vp.SubAccountCreationId.LegalBusinessName,
      getInputState: () => 'required',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});

        return <TextField placeholder={t('LegalBusinessName.placeholder')} variant="outlineShadow" {...fieldData} />;
      },
      showField: () => true,
      validate: () => Yup.mixed().required(),
    },
    {
      label: () => t('OriginatorName.label'),
      fieldName: vp.SubAccountCreationId.OriginatorName,
      getInputState: () => 'required',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});

        return (
          <TextField
            placeholder={t('OriginatorName.placeholder')}
            variant="outlineShadow"
            {...fieldData}
            maxLength={30}
          />
        );
      },
      showField: () => true,
      tooltip: () => <Tooltip information={t('OriginatorName.information')} position="top" />,
      validate: () => Yup.string().required().max(30, t('OriginatorName.information')),
    },
    {
      label: () => t('OriginatorShortName.label'),
      fieldName: vp.SubAccountCreationId.OriginatorShortName,
      getInputState: () => 'required',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});

        return (
          <TextField
            placeholder={t('OriginatorShortName.placeholder')}
            variant="outlineShadow"
            {...fieldData}
            maxLength={15}
          />
        );
      },
      showField: () => true,
      tooltip: () => <Tooltip information={t('OriginatorShortName.information')} position="top" />,
      validate: () => Yup.string().required().max(15, t('OriginatorShortName.information')),
    },
    {
      label: () => t('EmailAddress.label'),
      fieldName: vp.SubAccountCreationId.EmailAddress,
      getInputState: () => 'required',
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({});

        return (
          <TextField
            placeholder={t('EmailAddress.placeholder')}
            {...fieldData}
            preset="email"
            variant="outlineShadow"
          />
        );
      },
      showField: () => true,
      tooltip: () => <Tooltip information={t('EmailAddress.information')} position="top" />,
      validate: () => Yup.string().email().required(),
    },
  ];
};
